import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';
import Navbar from '../components/NavBar';
import '../App.css';

const BlogPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('Ziyaretçi');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUsername(payload.username || 'Ziyaretçi');
      } catch {
        setUsername('Ziyaretçi');
      }
    }
  }, []);

  const sortedPosts = [...blogPosts].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  return (
    <>
      <Navbar username={username} />
      <div style={{ padding: '40px 20px', maxWidth: 1300, margin: '0 auto' }}>
        <h1 style={{
          fontSize: '2.8rem',
          marginBottom: '40px',
          textAlign: 'center',
          color: '#0f172a',
          fontWeight: '800',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 12
        }}>
          <span role="img" aria-label="book">📘</span> HVAC-Assist Blog
        </h1>

     <div
  style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '30px',
    justifyContent: 'center',
  }}
>

          {sortedPosts.map((post) => (
            <div
              key={post.slug}
              onClick={() => navigate(`/blog/${post.slug}`)}
             style={{
  backgroundColor: '#ffffff',
  borderRadius: 16,
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.06)',
  overflow: 'hidden',
  width: 320,
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.25s ease, box-shadow 0.25s ease',
  cursor: 'pointer',
}}

         onMouseEnter={(e) => {
  e.currentTarget.style.transform = 'translateY(-6px)';
  e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.12)';
}}
onMouseLeave={(e) => {
  e.currentTarget.style.transform = 'translateY(0)';
  e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.06)';
}}

            >
              <img
                src={post.image}
                alt={post.title}
                style={{
                  width: '100%',
                  height: 180,
                  objectFit: 'cover',
                  borderRadius: '8px',
                  marginBottom: '16px'
                }}
              />

              <div style={{ padding: '20px 24px', flex: 1 }}>
                <h2 style={{ fontSize: '1.4rem', marginBottom: 8, color: '#1e293b' }}>
                  {post.title}
                </h2>
                <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: 4 }}>
                  📅 {post.date} &nbsp;&nbsp;|&nbsp;&nbsp; 🏷️ {post.category}
                </p>
               
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/blog/${post.slug}`);
                  }}
                  style={{
                    padding: '10px 16px',
                    backgroundColor: '#2563eb',
                    color: 'white',
                    border: 'none',
                    borderRadius: 6,
                    cursor: 'pointer',
                    fontWeight: '600',
                  }}
                >
                  Devamını Oku →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BlogPage;
